import React, { useState, useEffect } from 'react'
import LoginHeader from '../../components/header/Loginheader'
import './MiniAgentTransactionHistory.css';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../../src/constant.js';

function MiniAgentTransactionHistory() {
    const [currentPage, setCurrentPage] = useState(1);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const itemsPerPage = 6;
    const navigate = useNavigate();

    // Fetch transaction data from API
    const fetchTransactionHistory = async (page = 1) => {
        try {
            setLoading(true);
            const token = localStorage.getItem('auth_token');
            
            const response = await fetch(
                `${API_URL}/api/customer/transaction-history?page=${page}&per_page=${itemsPerPage}`, 
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (!response.ok) {
                throw new Error('Failed to fetch transaction history');
            }

            const data = await response.json();
            setTransactions(data.transactions || []);
            setError('');
            
        } catch (err) {
            setError(err.message);
            console.error('Error fetching transaction history:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTransactionHistory(currentPage);
    }, [currentPage]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    // Calculate pagination details
    const totalPages = Math.ceil(transactions.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedTransactions = transactions.slice(startIndex, startIndex + itemsPerPage);

    // Loading icon component
    const LoadingIcon = () => (
        <div className="loading-container">
            <div className="loading-spinner"></div>
            <p style={{ marginTop: '10px', color: 'white' }}>Loading transaction history...</p>
        </div>
    );

    if (loading) {
        return (
            <div className="pt-5" style={{ backgroundColor: "#001964" }}>
                <LoginHeader />
                <div className="wallet-container">
                    <div className="mini-transaction-table">
                        <h2>TCUK Mini Advertise Agent Wallet</h2>
                        <h3>Transaction History</h3>
                        <button className="mini-close-btn" onClick={() => navigate("/customer/wallet")}>✕</button>
                        <LoadingIcon />
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="pt-5" style={{ backgroundColor: "#001964" }}>
                <LoginHeader />
                <div className="wallet-container">
                    <div className="mini-transaction-table">
                        <h2>TCUK Mini Advertise Agent Wallet</h2>
                        <h3>Transaction History</h3>
                        <button className="mini-close-btn" onClick={() => navigate("/customer/wallet")}>✕</button>
                        <div style={{ textAlign: 'center', padding: '50px', color: 'white' }}>
                            Error: {error}
                            <br />
                            <button 
                                onClick={() => fetchTransactionHistory(currentPage)} 
                                style={{ 
                                    marginTop: '10px', 
                                    padding: '8px 16px', 
                                    backgroundColor: '#003087', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Retry
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="pt-5" style={{ backgroundColor: "#001964" }}>
            <LoginHeader />
            <div className="wallet-container">
                <div className="mini-transaction-table">
                    <h2>TCUK Mini Advertise Agent Wallet</h2>
                    <h3>Transaction History</h3>
                    <button className="mini-close-btn" onClick={() => navigate("/customer/wallet")}>✕</button>
            
                    <table className="user-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Earned Date</th>
                                <th>TCUK Ref.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedTransactions.length > 0 ? (
                                paginatedTransactions.map((transaction, index) => (
                                    <tr key={transaction.id || index}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{transaction.customer_name}</td>
                                        <td>{transaction.earned_date}</td>
                                        <td>{transaction.tcuk_ref}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center" }}>
                                        No transactions found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="pagination">
                        <button 
                            className="page-btn" 
                            onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                            disabled={currentPage === 1}
                        >
                            &lt;
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                                onClick={() => handlePageChange(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}
                        <button 
                            className="page-btn" 
                            onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
                            disabled={currentPage === totalPages}
                        >
                            &gt;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MiniAgentTransactionHistory;